import React, { useState, useEffect } from "react";
import axiosInstance from "../services/authWrapper";
import { BASE_URL } from "../config/index";
import GraphData from "./GraphData";
import { GraphSkeleton } from "../components/Dashboard/SkeletonLoaders";

import SummaryCards from "../components/Dashboard/SummaryCards";
import TenantMetricsSection from "../components/Dashboard/TenantMetricsSection";
import LandlordMetricsSection from "../components/Dashboard/LandlordMetricsSection";

const Dashboard = () => {
  const [graphdata, setGraphData] = useState({});
  const [loading, setLoading] = useState(true);
  const [durationType, setDurationType] = useState("daily");

  useEffect(() => {
    loadGraphData(durationType);
  }, [durationType]);

  const loadGraphData = async (type) => {
    try {
      setLoading(true);
      const axiosRes = await axiosInstance({
        method: "GET",
        headers: { "x-access-token": localStorage.getItem("token") },
        url: `${BASE_URL}/admin/graphdata?type=${type}`,
      });
      setLoading(false);
      if (axiosRes.data.success) {
        setGraphData(axiosRes.data.success_res);
      }
    } catch (err) {
      setLoading(false);
      console.log("loadGraphData [ERROR] =>", err);
    }
  };

  return (
    <>
      <div className="cardcontainer">
        <SummaryCards loading={loading} graphdata={graphdata} />
      </div>

      <TenantMetricsSection />

      <LandlordMetricsSection />

      {loading ? (
        <GraphSkeleton />
      ) : (
        <GraphData
          graphState={graphdata}
          onDurationChange={setDurationType}
          durationType={durationType}
        />
      )}
    </>
  );
};

export default Dashboard;
